import apiRoutes from 'router/routes/ApiRoutes';

import FetchHelpers from 'utils/FetchHelpers';

export default {
  async index(params) {
    const url = apiRoutes.dealsSummaryPath(params);
    return FetchHelpers.get(url, params);
  },
  async show(params) {
    const url = apiRoutes.dealsSummaryPath(params);
    return FetchHelpers.get(url, params);
  },
};
